export default "__VITE_ASSET__tVCMKpy$__"